"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class GetReports {
    static getAttributeTypeMap() {
        return GetReports.attributeTypeMap;
    }
}
GetReports.discriminator = undefined;
GetReports.attributeTypeMap = [
    {
        "name": "reports",
        "baseName": "reports",
        "type": "Array<GetReportsReports>"
    }
];
exports.GetReports = GetReports;
//# sourceMappingURL=getReports.js.map